// extracted by mini-css-extract-plugin
export default {"loading":"Parent_loading__Wk2tH","badges":"Parent_badges__vyGbq"};